import {createApp} from "vue";
import {useAuthStore} from "@/store/auth";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";

const appInstance = createApp(App);
appInstance.use(store);

import { createPinia } from 'pinia';
const pinia = createPinia();
appInstance.use(pinia);


// import Select2 from 'vue3-select2-component';
// appInstance.component('Select2', Select2);


// Initialize auth state
const authStore = useAuthStore();
const token = localStorage.getItem('token');
if (token) {
    try {
        authStore.setToken(token);
        await authStore.fetchUser().catch(() => {
            console.info('Failed to fetch user on init:');
             authStore.clearToken();
            router.push('/signin-otp');
        });

    } catch (error) {
        console.error('Error setting token on init:', error);
        router.push('/signin-otp');
    }
}else{
    router.push('/signin-otp');
}

appInstance.use(router);
appInstance.use(ArgonDashboard);



//start toaster alert
import {updateGlobalOptions} from "vue3-toastify";
import "vue3-toastify/dist/index.css";

updateGlobalOptions({
    autoClose: 5000,
    style: {
        opacity: '1',
        userSelect: 'initial',
    },
    "position": "top-center",
    "rtl": true,
    "transition": "slide",
    "dangerouslyHTMLString": true
});
//end toaster alert


//start options for axios

import axios from "axios";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Don't set Content-Type for FormData (let browser set it with boundary)
        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";
        }
        
        config.headers["Accept"] = "application/json";
        
        return config;
    }
    // (error) => {
    //     return Promise.reject(error);
    // }
);

//end options for axios


appInstance.mount("#app");
